/**
 * Code Intended to execute on Azure SISU pages
 */

 import $ from "jquery";

$(function(){
    var azureSocialSisuDiv = $(".portal-sign-in .social-sisu-form");
    if( azureSocialSisuDiv && azureSocialSisuDiv.length > 0) {
        initSocialSisuHandlers();
    }
});

function initSocialSisuHandlers(){
    // want to mark email on social sisu as disabled for updates
    $(".portal-sign-in .social-sisu-form").find("#email").prop('disabled', true);
}